import { kea } from 'kea'
import PropTypes from 'prop-types'

import rootLogic from '~/scenes/logic'
import { selector as configSelector } from '~/config'


export default kea({
  path: () => ['scenes', 'contact', 'account'],

  connect: {
    actions: [
      rootLogic, [
        'auth0Authenticated',
      ]
    ],
    values: [
      rootLogic, [
        'auth0Settings'
      ]
    ]
  },
  selectors : ({ constants, selectors }) => ({
    config: [
      () => [
        configSelector
      ], (config) => {
        return config
      },
      PropTypes.object
    ]
  })
})
